import {
  Box,
  Columns,
  ContentBlock,
  Divider,
  Heading,
  Stack,
} from 'braid-design-system';
import React from 'react';

import { countries } from 'src/shared/config';
import { useLocalized } from 'src/shared/hooks';

import InfosItem from './components/InfosItem';
import candidateImg from './img/CandidateMatching.svg';
import searchImg from './img/SearchSaved.svg';
import successImg from './img/SuccessHifive.svg';

const SEEKInfos = () => {
  const Infosdata = [
    {
      src: searchImg,
      description: useLocalized({
        AU: `Over 50% of candidates who looked online to find a job in the last 12 months used SEEK`,
        NZ: `75% of all New Zealander's who changed jobs in the last 12 months used SEEK`,
      }),
    },
    {
      src: successImg,
      description: useLocalized({
        AU: `33% of candidates found their job on SEEK in the last 12 months`,
        NZ: `SEEK placed more New Zealanders in jobs than any other channel in the last 12 months`,
      }),
    },
    {
      src: candidateImg,
      description: useLocalized({
        AU: `75% of candidates who found their job on SEEK would go to SEEK first to find their next job`,
        NZ: `Over 75% of candidates who found their job on SEEK would go to SEEK first to find their next job`,
      }),
    },
  ];

  return (
    <ContentBlock>
      <Box
        marginBottom="xlarge"
        marginTop={{ desktop: 'medium', mobile: 'large' }}
        paddingX={{ desktop: 'none', mobile: 'medium' }}
      >
        <Stack space="xlarge">
          <Heading align="center" level="2">
            Post your ad on {useLocalized(countries)}&apos;s most visited
            employment site
          </Heading>
          <Columns
            align="center"
            collapseBelow="desktop"
            space={{ desktop: 'small', mobile: 'xlarge' }}
          >
            {Infosdata.map(({ src, description }) => (
              <InfosItem
                key={description}
                imgSrc={src}
                description={description}
              />
            ))}
          </Columns>
        </Stack>
      </Box>
      <Box paddingX={{ desktop: 'none', tablet: 'xlarge', mobile: 'small' }}>
        <Divider />
      </Box>
    </ContentBlock>
  );
};

export default SEEKInfos;
